import { getDefaultStore } from "jotai"
import { storesDictAtom } from "../global/AtomsProvider"
import * as Localization from 'expo-localization'
import timezones from './timezones'
import { updateStoreTimezone } from "../global/Firebase/firebase"
import { rethrowUnlessWRefusal } from "../global/Write/writeW"

// Re-export pure timezone functions from timezoneUtils for backward compatibility
export {
  getLocalStoreDate,
  getStoreBusinessDate,
  businessDayRangeForStore,
  dateRangeWithTimezoneAndAutoclose,
  businessDateRangeStrings,
  getDailyStatID,
  dailyStatIDForBusinessDay,
  businessDayAsLocalDate,
  dailyStatIDForRecord,
  dailyStatIDForRecordOrNull,
  getMonthlyStatDocID,
  normalizeDate,
  storeLocalDateAtTime,
} from './timezoneUtils'

// setTimezone requires firebase, so it stays here
export const setTimezone = (storeId) => {
  let jotaiStore = getDefaultStore()
  let storesDict = jotaiStore.get(storesDictAtom)
  let store = storesDict[storeId]
  if (store.timezone) return
  let deviceTimezone = Localization.getCalendars()[0].timeZone
  var timezone = timezones[77]
  for (let value of timezones) {
    for (let utcValue of value.utc) {
      if (utcValue === deviceTimezone) {
        timezone = value
      }
    }
  }
  updateStoreTimezone(store.ref, timezone).catch(rethrowUnlessWRefusal) // P9b review 1: a W refusal was already announced
}
